import DevConsoleAPI from "../../api/DevConsole";
import DevProjectAPI from "../../api/DevProject";
import { DC_CONSUMER_URL, DC_ENTERPRISE_URL } from "../../config";
import { messageTypes } from "./msgHelper";
import { FtuSchema, appStoreProviders } from "./objectHelper";

export const getStatus = (status, statusHelper, isStyle = false) => {
  // status= api data, statusHelper = status declared in const in helperStatus
  for (var key of Object.keys(statusHelper)) {
    if (status === statusHelper[key].status) {
      return (
        <div>
          {isStyle && statusHelper[key]?.icon && (
            <img className="mrc-10" src={statusHelper[key]?.icon} />
          )}
          <span className={isStyle ? statusHelper[key].class : ""}>
            {statusHelper[key].name}
          </span>
        </div>
      );
    }
  }
  return "-";
};

export const sliceString = (start, end, str, isEllipsis) => {
  if (isEllipsis) {
    if (str && str?.length > end) return str.slice(start, end).concat("...");
  }
  return (str && str.slice(start, end)) || str;
};

export const getFTUData = (type) => {
  for (let key of Object.keys(FtuSchema)) {
    if (type === key) {
      return FtuSchema[key];
    }
  }
};

export const GetQueryParam = (query) => {
  return new URLSearchParams(window.location.search).get(query);
};

export const getAppStoreData = (appInfo) => {
  const data = appStoreProviders[appInfo.appOS];
  const intentData =
    appInfo.appOS === "ios"
      ? appStoreProviders["ios-intent"]
      : appStoreProviders["android-intent"];

  if (data) {
    const modifiedData = { ...data, url: appInfo.playstoreUrl };
    const intent = { ...intentData, url: appInfo.deepLink };

    return !appInfo.deepLink || appInfo.deepLink === ""
      ? [modifiedData]
      : [modifiedData, intent];
  }
  return [];
};

export const getMsg = (errorCode) => {
  if (messageTypes[errorCode] && messageTypes[errorCode]?.code) {
    return messageTypes[errorCode].msg;
  } else {
    return "Something went wrong;";
  }
};

export const getProjAppCount = async (orgId) => {
  // to get projects/apps allowed/used count
  try {
    let project = new DevProjectAPI();
    let org = new DevConsoleAPI();
    let projectRes = await project.getAllProject();
    let orgRes = await org.getOrganization(orgId);
    const projectsData = projectRes?.data?.data;
    const orgData = orgRes?.data?.data;
    let result = {
      project: {
        used: projectsData?.length,
        allowed: orgData?.projectAllowed,
      },
      apps: {
        used: projectsData?.reduce(
          (prev, project) => prev + project?.appCount, // calculating the total apps used in each project
          0
        ),
        allowed: orgData?.appsAllowed,
      },
    };
    return result;
  } catch (err) {
    console.log(err);
  }
};

/**  */
export const migrateToBUBasedDC = (location, wLocation) => {  
  const query = new URLSearchParams(location.search);
  let tags = query.get('userTags');
  if(!tags) {
    const hashQuery = new URLSearchParams(location.hash);
    tags = hashQuery.get('userTags');
  }
  if(tags) {
    let dcURL = (tags === 'enterprise') ? DC_ENTERPRISE_URL : DC_CONSUMER_URL;
    console.log('}}}}}}}DC_ENTERPRISE_URL ', DC_ENTERPRISE_URL)
    console.log('}}}}}}}DC_CONSUMER_URL ', DC_CONSUMER_URL)
    console.log('}}}}}}}--------dcURL ', dcURL)
    console.log('}}}}}}}--------location.origin ', wLocation.origin)
    console.log('}}}}}}}--------dcURL ', wLocation.origin !== dcURL)
    if(wLocation.origin !== dcURL) return dcURL;
  }
  return null;
}